import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class MetricLibraryController extends Controller {
	@tracked submitInProgress = false;
}
